<template>
  <div>
    <ElibraryMain kategori="buku"></ElibraryMain>
    <AppFooter></AppFooter>
  </div>
</template>

<script>
import ElibraryMain from "@/components/public-e-library/ElibraryMain.vue";
import AppFooter from "@/components/AppFooter.vue";

export default {
  name: 'ELibraryBukuView',
  components: {
    AppFooter,
    ElibraryMain
  },
  data() {
    return {

    }
  },
  methods: {
  },
  mounted() {
  }

}
</script>

<style scoped>

</style>